import React, { useRef, useEffect, useState } from 'react';
import './navbar.css';
import cogIcon from '../images/cog_header.png'
import SearchBar from '../SearchBar/SearchBar.js'

export default function Navbar({ openCustomizationModal, clickedAddNewBusOrTrain }) {
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    // Function to update the time
    const updateClock = () => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const formattedTime = `${hours % 12 || 12}:${minutes < 10 ? '0' + minutes : minutes} ${hours >= 12 ? 'pm' : 'am'}`;
      setCurrentTime(formattedTime);
    };

    // Update the clock immediately on mount
    updateClock();

    // Set up an interval to update the clock every second
    const intervalId = setInterval(updateClock, 5000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className='navbar-container'>
      <div className='navbar-top-half'>
        <div className='navbar-title-container'>
          Choocago!
        </div>
      </div>
      <div className='navbar-bottom-half'>
        <SearchBar clickedAddNewBusOrTrain={clickedAddNewBusOrTrain}/>
        <img src={cogIcon} className='navbar-cog-image' onClick={openCustomizationModal}/>
      </div>
    </div>
  );
}
